var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.406 47.973"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 63.406,
    height: 47.973
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3,5.858l-14.1,14.1V5.858H16.108V40.871H22.2v-12.3L44.913,5.858Z",
    transform: "translate(18.415 7.102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.647,16.109l11.5,13.7h7.946l-11.5-13.7Z",
    transform: "translate(23.313 18.164)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.745,16.225A10.06,10.06,0,0,0,18.572.03C18.316.011,18.058,0,17.8,0H0V34.047H6.191V20.119H19.345a3.869,3.869,0,0,1,0,7.738H9.369l5.2,6.191h4.781a10.061,10.061,0,0,0,6.4-17.821m-19.554-2.3V6.191H17.8a3.869,3.869,0,0,1,0,7.738Z",
    transform: "translate(0 -0.001)"
  })))));
};
export default SvgLogo;